import { Injector } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { XEVPRMAck } from "../../../Data/Art57Data/XEVPRMAck";
import { Art57Node } from "../Art57Node";
import { DateUtil } from "../../../DateUtil";
import { TreeNodeAcknoledgmentList } from "../../WebTraderNode/ListEntity/TreeNodeAcknoledgmentList";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNode } from "primeng/api";



export class TreeNodeXEVPRMAck extends Art57Node {
  constructor(private injector: Injector) {
    super(
      injector,
      new XEVPRMAck(
        new FormGroup({}),
        new FieldDefinition(injector),
        {}
      ),
      'Message Ack'
    );

    this.expanded = true;
    this.createChildTemplate();
  }

  reset() {
    this.children?.forEach((child) => {
      child.children = [];
      (child as Art57Node).refreshLabel();
    });

    this.data.model = {};
    this.refreshLabel();

    this.ioc!.get(LookupGetService).resetLocalNumberSequences();

  }

  override refreshLabel(): void {
    if (
      this.data &&
      this.data.model &&
      this.data.model.ichicsrmessageheader &&
      this.data.model.ichicsrmessageheader.messagenumb
    ) {
      this.label = this.data.model.ichicsrmessageheader.messagenumb;
    } else {
      this.label = this.labelTemplate;
    }
  }


  private createNodeTypeIfNoExist(type: new (...args: any[]) => Art57Node) {
    let foundNode: TreeNode | null = Art57NodeUtils.findFirstChildNodeOfType(this, type);
    if (foundNode == null) {
      foundNode = new type(this.injector, this);
      this.children?.push(foundNode);
    }

  }

  private importArt57Node(type: new (...args: any[]) => Art57Node, jsonObject: any, section: string, params: any) {
    if (jsonObject) {
      this.createNodeTypeIfNoExist(type);
      Art57NodeUtils.importNodeType(this, jsonObject, section, type, params);
    }
  }


  override setMessage(jsonObject: any): void {
    super.setMessage(jsonObject.messageacknowledgment);
    if (this.data.model.originalmessagedate && this.data.model.originalmessagedateformat) {
      this.data.model.originalmessagedate = DateUtil.getFormatedDate(this.data.model.originalmessagedateformat, this.data.model.originalmessagedate);
    }

    if (jsonObject) {
     this.importArt57Node(TreeNodeAcknoledgmentList, jsonObject, 'reportacknowledgment', '');
    }
  }

}